import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from '../../common/common.service';
import pdfMake from 'pdfmake/build/pdfmake';

// Service
import { ConfigService } from '../../infrastructure/config.service';
import { LoaderService } from '../../infrastructure/loader.service';
import { NetworkService } from '../../infrastructure/network.service';
import { DatePipe } from '@angular/common';

@Injectable()

export class SeedCropLossService {
  public selectedAccountNo: any;
  public isApproverUser = false;
  public isViewRequest = false;
  pdfDataObject: any;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  totalOrderCost = 0;
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  shipToAccountDetails: any = {};
  growerDetails: any = {};

  basePdfData: string;

  constructor(
    public configService: ConfigService,
    private networkService: NetworkService,
    public loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe,) {
    this.reviewRequestId = new BehaviorSubject(0);
  }

  reviewRequestId: BehaviorSubject<number>;

  public setRequestHeaderId(value: number) {
    this.reviewRequestId.next(value);
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  // Get landing banner message
  public getLandingBannerMessage() {
    return this.networkService.getRequest(this.configService.getSeedCropLossLandingBannerMessageUrl);
  }

  // Get Landing Grid Data
  public getLandingGridData(filters) {
    return this.networkService.postRequest(this.configService.getSeedCropLossLandingGridDataUrl, filters);
  }

  // Get Landing Export Data
  public getLandingExportData(filters) {
    return this.networkService.postRequest(this.configService.getSeedCropLossLandingExportDataUrl, filters);
  }

  // Get invoiced product list for grid
  public getInvoicedProductItems(filters) {
    return this.networkService.postRequest(this.configService.getInvoicedProductListUrl, filters);
  }

  // Get Ship To Accounts
  public getShipToAccountDataList() {
    return this.networkService.getRequest(this.configService.getSeedCropLossShipToAccountDataUrl);
  }

  // Get Sold To Accounts
  public getSoldTo(accountNumber) {
    return this.networkService.getRequest(this.configService.getSeedCropLossSoldToFacilityDataUrl + '?accountNumber=' + accountNumber);
  }

  // Get Credit To Accounts
  public getCreditToAccounts(accountNumber, shipToAccountParentNumber) {
    return this.networkService.getRequest(this.configService.getSeedCropLossCreditToAccountDataUrl + '?accountNumber=' + accountNumber + '&shipToAccountParentNumber=' + shipToAccountParentNumber);
  }

  // Get lot master list
  public getLotMasterList(accountNumber) {
    return this.networkService.getRequest(this.configService.getCropLossLotMasterItems() + '?accountNumber=' + accountNumber);
  }

  // Get product line list
  public getProductLineList() {
    return this.networkService.getRequest(this.configService.getCropLossProductLineListUrl);
  }

  // Get Technology list
  public getTechnologyList() {
    return this.networkService.getRequest(this.configService.getCropLossTechnologyListUrl);
  }

  // Get account user
  public getAccountUser(accountNumber) {
    return this.networkService.getRequest(this.configService.getCropLossAccountUserRequestUrl + '?accountNumber=' + accountNumber);
  }

  // Get Grower list by account
  public getGrowerListByFilter(filters, growerFilters) {
    return this.networkService.postRequest(this.configService.getCropLossGrowerSearchUrl + '?accountNumber=' + filters.shipToAccount + '&cropYear=' + filters.cropYear, growerFilters);
  }

  public saveCropLoss(data) {
    return this.networkService.postRequest(this.configService.saveCropLossUrl, data);
  }

  // Get Edit request detail
  public getEditDetail(requestHeaderId, isApprover) {
    if (isApprover) {
      return this.networkService.getRequest(this.configService.getCropLossEditDetailDataUrl + '?requestHeaderId=' + requestHeaderId + '&isApprover=' + isApprover);
    }
    else {
      return this.networkService.getRequest(this.configService.getCropLossEditDetailDataUrl + '?requestHeaderId=' + requestHeaderId + '&isApprover=' + 0);
    }
  }

  // delete Draft request
  public deleteDraftRequest(requestId) {
    return this.networkService.postRequest(this.configService.deleteCropLossDraftRequestDetail(), requestId);
  }

  public submitReviewRequest(data) {
    return this.networkService.postRequest(this.configService.submitReviewRequestCropLossUrl, data);
  }

  public approveReviewRequest(data) {
    return this.networkService.postRequest(this.configService.approveReviewRequestCropLossUrl, data);
  }

  public getEffectiveConfigData() {
    return this.networkService.getRequest(this.configService.getEffectiveConfigDataCropLossUrl);
  }

  // send Crop Loss new request Email
  public sendCropLossNewRequestEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendCropLossNewRequestEmail(), emailObject);
  }

  public getItemsLicenseData(data) {
    return this.networkService.postRequest(this.configService.getItemsLicenseCropLossData, data);
  }

  // Get Treatment data
  public getItemsTreatmentData() {
    return this.networkService.getRequest(this.configService.getTreatmentDataCropLossUrl);
  }

  // Get Admin Config Message list
  public getAdminConfigMessageList() {
    return this.networkService.getRequest(this.configService.getCropLossAdminConfigMessageListUrl);
  }

  public generatePdf(RequestHeaderId) {
    if (RequestHeaderId) {
      this.loaderService.setLoaderStatus(true);
      this.getEditDetail(RequestHeaderId, 0).subscribe((result) => {
        if (result) {
          if (result !== undefined && result.failedProductList.length > 0) {
            this.pdfDataObject = result;
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).download('Crop Loss_' + result.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
          } else {
            this.toastrService.error('No data available for RequestNumber #' + result.webOrderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition() {
    const orderCreateDate = this.datePipe.transform(this.pdfDataObject.createTimestamp, 'MMMM dd, yyyy');
    const createDateTime = this.pdfDataObject.createdOnString;
    this.deliverToAccountdetails = {};
    this.soldToAccountdetails = {};
    this.shipToAccountDetails = {};

    if (this.pdfDataObject.shipToAccountDetail) {
      this.shipToAccountDetails.AccountNumber = this.pdfDataObject.shipToAccountDetail.accountNumber;
      this.shipToAccountDetails.AccountName = this.pdfDataObject.shipToAccountDetail.accountName;
      this.shipToAccountDetails.Address1 = this.pdfDataObject.shipToAccountDetail.address1;
      this.shipToAccountDetails.Address2 = this.pdfDataObject.shipToAccountDetail.Address2;
      this.shipToAccountDetails.AccountCity = this.pdfDataObject.shipToAccountDetail.city;
      this.shipToAccountDetails.AccountState = this.pdfDataObject.shipToAccountDetail.state;
      this.shipToAccountDetails.AccountZipCode = this.pdfDataObject.shipToAccountDetail.zipCode;
    }

    if (this.pdfDataObject.growerDetail) {
      this.growerDetails.GrowerName = this.pdfDataObject.growerDetail.businessName ? this.pdfDataObject.growerDetail.businessName : this.pdfDataObject.growerDetail.growerName;
      this.growerDetails.GMK = this.pdfDataObject.growerDetail.gmk;
      this.growerDetails.growerGLN = this.pdfDataObject.growerDetail.growerGLN;
      this.growerDetails.Address1 = this.pdfDataObject.growerDetail.address1;
      this.growerDetails.Address2 = this.pdfDataObject.growerDetail.address2;
      this.growerDetails.City = this.pdfDataObject.growerDetail.city;
      this.growerDetails.State = this.pdfDataObject.growerDetail.state;
      this.growerDetails.Zip = this.pdfDataObject.growerDetail.zip;
      this.growerDetails.PrimaryPhoneNumber = this.pdfDataObject.growerDetail.primaryPhoneNumber;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: '', bold: true }, { text: 'Grower:', bold: true }];
      valueList = [
        'Account #: ' + this.shipToAccountDetails.AccountNumber + ' \n' +
        'Crop Loss Request: ' + this.pdfDataObject.webOrderNumber + ' \n' +
        this.shipToAccountDetails.AccountName + ' \n' +
        this.shipToAccountDetails.Address1 + ' \n' +
        this.shipToAccountDetails.AccountCity + ', ' + this.shipToAccountDetails.AccountState + ' ' + this.shipToAccountDetails.AccountZipCode + ' \n',

        this.growerDetails.GrowerName + ' \n' +
        this.growerDetails.Address1 + ', ' + this.growerDetails.City + ', ' + this.growerDetails.State + ' - ' + this.growerDetails.Zip + ' \n' +
        this.growerDetails.PrimaryPhoneNumber + ' \n' +
        'Grower GMK: ' + this.growerDetails.GMK + ' ' + 'Grower GLN:' + this.growerDetails.growerGLN
      ];
    }

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: orderCreateDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          style: 'pageText',
          widths: ['25%', '50%', '25%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: [{
            image: 'data:image/png;base64,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',
            width: 60,
            height: 20,
            alignment: 'left',
            fit: [100, 100]
          },
          {
            text: orderCreateDate, alignment: 'right', fontSize: 15, style: 'pageText', marginRight: 30
          }]
        },
        {
          style: 'headername',
          table: {
            body: [
              [
                'Crop Loss Request ' + this.pdfDataObject.webOrderNumber
              ],
            ]
          },
          fontSize: 18,
          layout: 'noBorders',
          marginTop: 10
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['\n Dear ' + this.pdfDataObject.createUser + ',']
            ]
          },
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          text: [
            'A Crop Loss Request has been submitted for ',
            { text: this.shipToAccountDetails.AccountName, bold: true },
            '.Please review the receipt below to ensure the request is correct. Reference number ' + this.pdfDataObject.webOrderNumber + ' in all communications.',
            {
              text: 'Your WinField Sales Rep will be notified to Approve this request.',
              color: '#ED4454',
              fontSize: 8,
              bold: true,
            }
          ],
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 2 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#d7dcee' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#d7dcee' : '#d7dcee';
            },
          }
        },
        this.getContractPdfObject(this.pdfDataObject.failedProductList),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis Crop Loss Request was submitted by ' + this.pdfDataObject.createUser + ' on ' + createDateTime
                + ' (CST). Note that requested units could be subject to change. If you have questions regarding this request, please contact Winfield United Customer Service #855-494-6343.'],
            ]
          },
          layout: 'noBorders',
          marginTop: 20
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        headername: {
          fontSize: 18,
          bold: true,
          color: '#0b3f54'
        },
        tableHeader: {
          bold: true,
          fillColor: '#F5F6FA',
          fontSize: 8,
          color: '#0b3f54',
          border: [true, true, true, true],
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(failedProductList) {
    const tblObject = [];
    const requestDetails = failedProductList;
    const tbl = {
      layout: 'noBorders',
      table: {
        widths: ['37%', '15%', '15%', '15%', '18%'],
        color: '#0b3f54',
        body: [
          [{
            text: 'Failed Product',
            style: 'tableHeader', marginTop: 5,
          },
          {
            text: 'Item',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Lot',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Failed Units',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'UOM',
            style: 'tableHeader', alignment: 'center'
          },
          ],
          ...requestDetails.map(cl => [
            { text: cl.itemDescription },
            { text: cl.itemId, alignment: 'center' },
            { text: cl.lotNumber, alignment: 'center' },
            { text: cl.unitsFailed, alignment: 'center' },
            { text: cl.uom, alignment: 'center' },
          ])
        ]
      },
      style: 'tablefont',
      marginTop: 5,
    };
    tblObject.push(tbl);
    return tblObject;
  }
}
